module.exports = __webpack_public_path__ + "static/media/Bigichev_2_t.e44081fe.jpg";